import { Dialog, Box } from '@mui/material';
import { useIsMobile } from '@/hooks/useIsMobile';
import { WorkOrderDetailContent } from '@/features/workorders/WorkOrderDetailContent';

interface WorkOrderDetailDialogProps {
  workOrderId: string | null;
  open: boolean;
  onClose: () => void;
}

export function WorkOrderDetailDialog({ workOrderId, open, onClose }: WorkOrderDetailDialogProps) {
  const isMobile = useIsMobile();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      maxWidth="xl"
      fullWidth
      scroll="paper"
    >
      <Box sx={{ p: { xs: 2, sm: 3 }, overflow: 'auto' }}>
        {workOrderId && (
          <WorkOrderDetailContent workOrderId={workOrderId} onClose={onClose} cardVariant="outlined" />
        )}
      </Box>
    </Dialog>
  );
}
